import React from 'react';
import { Typography, Layout, Divider, Table } from 'antd';

const { Title, Paragraph, Text } = Typography;
const { Content } = Layout;

const TermsFR = () => {
  // Colonnes pour le tableau SLA (Section 6 de l'Annexe 1)
  const slaColumns = [
    { title: 'Niveau', dataIndex: 'niveau', key: 'niveau', render: (text: string) => <Text strong>{text}</Text> },
    { title: 'Description', dataIndex: 'description', key: 'description' },
    { title: 'Délai de réponse', dataIndex: 'reponse', key: 'reponse' },
    { title: 'Objectif de résolution', dataIndex: 'resolution', key: 'resolution' },
  ];

  const slaData = [
    { key: '1', niveau: 'Critique (P1)', description: 'Interruption totale du service de diffusion', reponse: '4 heures ouvrées', resolution: '24 heures' },
    { key: '2', niveau: 'Majeur (P2)', description: 'Fonctionnement altéré sans interruption totale', reponse: '1 jour ouvré', resolution: '3 jours ouvrés' },
    { key: '3', niveau: 'Mineur (P3)', description: 'Dysfonctionnement non bloquant', reponse: '2 jours ouvrés', resolution: 'Correctif planifié' },
  ];

  // Colonnes pour le tableau RGPD (Section 3 de l'Annexe 3)
  const rgpdColumns = [
    { title: 'Finalité', dataIndex: 'finalite', key: 'finalite', render: (text: string) => <Text strong>{text}</Text> },
    { title: 'Base légale', dataIndex: 'base', key: 'base' },
  ];

  const rgpdData = [
    { key: '1', finalite: 'Gestion du compte client', base: 'Exécution du contrat (art. 6.1.b RGPD)' },
    { key: '2', finalite: 'Gestion des abonnements et facturation', base: 'Obligation légale' },
    { key: '3', finalite: 'Support technique', base: 'Intérêt légitime' },
    { key: '4', finalite: 'Sécurité et prévention des abus', base: 'Intérêt légitime' },
    { key: '5', finalite: 'Amélioration des services', base: 'Intérêt légitime' },
    { key: '6', finalite: 'Respect des obligations réglementaires', base: 'Obligation légale' },
  ];

  return (
    <Layout style={{ padding: '1.5em 0.75em' }}>
        <Typography>
          <Title level={2} style={{ textAlign: 'center', textTransform: 'uppercase' }}>
            CONDITIONS GÉNÉRALES D'UTILISATION
          </Title>
          <Paragraph style={{ textAlign: 'center' }}>
            <Text strong>Application Web et Mobile " MusicTMM-Universum "</Text>
          </Paragraph>

          <Divider />

          <Title level={4}>1. IDENTIFICATION DE L'ÉDITEUR</Title>
          <Paragraph>
            La plateforme web et mobile " MusicTMM-Universum " (ci-après la " Plateforme ") est éditée par :
          </Paragraph>
          <Paragraph>
            <Text strong>MusicTMM SAS</Text> Société par actions simplifiée<br />
            Siège social : 99 Avenue Achille Peretti, 92200 Neuilly-sur-Seine, France<br />
            Email : <Text underline>hello@musictmm.fr</Text>
          </Paragraph>
          <Paragraph>
            La Société est titulaire des droits de propriété intellectuelle relatifs à la Plateforme.
          </Paragraph>

          <Title level={4}>2. OBJET</Title>
          <Paragraph>
            Les présentes Conditions Générales d'Utilisation (ci-après les " CGU ") ont pour objet de définir les conditions dans lesquelles la Société concède à des utilisateurs professionnels (ci-après le " Client ") un droit d'accès et d'utilisation de la Plateforme.
          </Paragraph>
          <Paragraph>
            Les CGU constituent un contrat au sens des articles 1101 et suivants du Code civil.
          </Paragraph>
          <Paragraph>
            <Text strong>La Plateforme est strictement réservée aux personnes morales ou aux professionnels agissant dans le cadre de leur activité commerciale.</Text>
          </Paragraph>

          <Title level={4}>3. ACCEPTATION</Title>
          <Paragraph>
            L'accès et l'utilisation de la Plateforme impliquent l'acceptation sans réserve des présentes CGU.
          </Paragraph>
          <Paragraph>
            Le Client déclare :
          </Paragraph>
          <ul>
            <li>agir à des fins professionnelles ;</li>
            <li>disposer de la capacité juridique et des pouvoirs nécessaires ;</li>
            <li>fournir des informations exactes et à jour.</li>
          </ul>

          <Title level={4}>4. DESCRIPTION DES SERVICES</Title>
          <Paragraph>
            La Plateforme permet notamment :
          </Paragraph>
          <ul>
            <li>la diffusion et la gestion de contenus musicaux dans des espaces commerciaux ;</li>
            <li>l'accès à des playlists éditoriales ou assistées par intelligence artificielle ;</li>
            <li>l'administration de comptes professionnels.</li>
          </ul>
          <Paragraph>
            La Société se réserve le droit de faire évoluer les fonctionnalités à tout moment, sous réserve d'en informer le Client en cas de modification substantielle.
          </Paragraph>

          <Title level={4}>5. LICENCE D'UTILISATION</Title>
          <Paragraph>
            La Société concède au Client une licence :
          </Paragraph>
          <ul>
            <li>non exclusive</li>
            <li>non cessible</li>
            <li>non transférable</li>
            <li>limitée à la durée du contrat</li>
          </ul>
          <Paragraph>
            La licence autorise uniquement :
          </Paragraph>
          <ul>
            <li>l'accès à la Plateforme ;</li>
            <li>l'utilisation des contenus musicaux conformément à leur destination professionnelle.</li>
          </ul>
          <Paragraph>
            <Text strong>Toute reproduction, extraction, reverse engineering, scraping ou exploitation non autorisée est strictement interdite.</Text>
          </Paragraph>
          <Paragraph>
            La base de données de la Plateforme est protégée conformément à la Directive 96/9/CE.
          </Paragraph>
          <Paragraph>
            L’enregistrement sur la Plateforme ne confère aucun droit d’utilisation du Service.
          </Paragraph>
          <Paragraph>
            <Text strong style={{ textDecoration: 'underline' }}>L’accès effectif au Service est subordonné à la signature d’un contrat commercial distinct entre MusicTMM SAS et le Client.</Text>
          </Paragraph>
          <Paragraph>
            L’accès à la Plateforme, y compris l’utilisation des contenus mis à disposition, ne constitue en aucun cas une exonération des obligations légales du Client relatives au paiement des redevances susceptibles d’être dues aux sociétés de gestion collective ou aux organismes chargés de la perception des droits d’auteur et des droits voisins, conformément à la réglementation applicable dans le territoire d’exploitation.
          </Paragraph>
          <Paragraph>
            L’accès au Service est fourni à titre onéreux dans les conditions prévues au contrat commercial distinct conclu entre la Société et le Client.
          </Paragraph>
          <Paragraph>
            Les CGU ne déterminent pas les conditions tarifaires applicables.
          </Paragraph>

          <Title level={4}>6. PROPRIÉTÉ INTELLECTUELLE</Title>
          <Paragraph>
            La Plateforme, ses algorithmes, son architecture, ses contenus, marques et bases de données demeurent la propriété exclusive de MusicTMM SAS.
          </Paragraph>
          <Paragraph>
            Aucun transfert de propriété intellectuelle n'est opéré au profit du Client.
          </Paragraph>

          <Title level={4}>7. CONTENUS ASSISTÉS PAR INTELLIGENCE ARTIFICIELLE</Title>
          <Paragraph>
            Certains contenus audio disponibles sur la Plateforme peuvent inclure des éléments générés ou assistés par des technologies d'intelligence artificielle, notamment des voix synthétiques, sans que cela implique l'imitation d'un artiste réel identifié.
          </Paragraph>
          <Paragraph>
            La Société veille à respecter les exigences de transparence prévues par la réglementation européenne applicable en matière d'intelligence artificielle.
          </Paragraph>

          <Title level={4}>8. DONNÉES PERSONNELLES</Title>
          <Paragraph>
            La Société agit en qualité de Responsable du traitement au sens du Règlement (UE) 2016/679 (RGPD).
          </Paragraph>
          <Paragraph>
            Les données collectées sont traitées aux fins :
          </Paragraph>
          <ul>
            <li>de gestion des comptes professionnels ;</li>
            <li>d'exécution contractuelle ;</li>
            <li>d'amélioration des services ;</li>
            <li>de respect des obligations légales.</li>
          </ul>
          <Paragraph>
            Les modalités complètes sont détaillées dans la Politique de Confidentialité accessible sur le site officiel.
          </Paragraph>

          <Title level={4}>9. OBLIGATIONS DU CLIENT</Title>
          <Paragraph>
            Le Client s'engage à :
          </Paragraph>
          <ul>
            <li>utiliser la Plateforme conformément à sa destination professionnelle ;</li>
            <li>ne pas porter atteinte aux droits de la Société ou de tiers ;</li>
            <li>assurer la sécurité de ses identifiants ;</li>
            <li>informer sans délai la Société de tout accès frauduleux.</li>
          </ul>
          <Paragraph>
            Toute utilisation abusive pourra entraîner la suspension immédiate du service.
          </Paragraph>

          <Title level={4}>10. RESPONSABILITÉ</Title>
          <Paragraph>
            La Société est tenue d'une obligation de moyens.
          </Paragraph>
          <Paragraph>
            La responsabilité de la Société ne saurait être engagée pour :
          </Paragraph>
          <ul>
            <li>pertes indirectes ;</li>
            <li>pertes d'exploitation ;</li>
            <li>manque à gagner ;</li>
            <li>atteinte à l'image.</li>
          </ul>
          <Paragraph>
            La responsabilité totale de la Société est limitée au montant des sommes effectivement versées par le Client au cours des douze (12) derniers mois.
          </Paragraph>
          <Paragraph>
            Cette limitation s’applique également aux annexes, y compris le SLA.
          </Paragraph>
          <Paragraph>
            La présente limitation ne s'applique pas en cas de faute lourde ou intentionnelle.
          </Paragraph>

          <Title level={4}>11. DISPONIBILITÉ</Title>
          <Paragraph>
            La Société s'efforce d'assurer une disponibilité raisonnable de la Plateforme.
          </Paragraph>
          <Paragraph>
            Aucune garantie de fonctionnement ininterrompu n'est accordée.
          </Paragraph>

          <Title level={4}>12. MODIFICATION DES CGU</Title>
          <Paragraph>
            La Société peut modifier les présentes CGU.
          </Paragraph>
          <Paragraph>
            Toute modification substantielle sera notifiée au Client dans un délai raisonnable.
          </Paragraph>
          <Paragraph>
            En cas de désaccord, le Client pourra résilier son contrat.
          </Paragraph>

          <Title level={4}>13. DURÉE ET RÉSILIATION</Title>
          <Paragraph>
            Les CGU s'appliquent pour la durée de l'utilisation des services.
          </Paragraph>
          <Paragraph>
            En cas de manquement grave, la Société pourra suspendre ou résilier l'accès après mise en demeure restée sans effet.
          </Paragraph>

          <Title level={4}>14. CESSION</Title>
          <Paragraph>
            La Société peut céder tout ou partie de ses droits et obligations à toute entité de son groupe ou dans le cadre d'une opération de restructuration, fusion ou acquisition.
          </Paragraph>

          <Title level={4}>15. DROIT APPLICABLE ET JURIDICTION</Title>
          <Paragraph>
            Les présentes CGU sont régies par le droit français.
          </Paragraph>
          <Paragraph>
            Tout litige relatif à leur interprétation ou exécution relèvera de la compétence exclusive des tribunaux de Paris.
          </Paragraph>

          <Title level={4}>16. FORCE MAJEURE</Title>
          <Paragraph>
            Aucune partie ne pourra être tenue responsable d’un manquement résultant d’un cas de force majeure au sens de l’article 1218 du Code civil.
          </Paragraph>

          <Title level={4}>17. DISPOSITIONS FINALES</Title>
          <Paragraph>
            Si une clause est déclarée invalide, les autres dispositions demeureront applicables.
          </Paragraph>
          <Paragraph>
            Les CGU constituent l'intégralité de l'accord entre les parties.
          </Paragraph>
        </Typography>


        <Title level={2}>ANNEXE 1 – SERVICE LEVEL AGREEMENT (SLA)</Title>
        <Paragraph>Applicable à la Plateforme « MusicTMM-Universum »</Paragraph>

        <Title level={3}>1. OBJET</Title>
        <Paragraph>
          La présente Annexe définit les engagements de niveau de service (Service Level Commitments) applicables à la plateforme SaaS « MusicTMM-Universum » exploitée par MusicTMM SAS (ci-après la « Société »).
        </Paragraph>
        <Paragraph>Elle précise :</Paragraph>
        <ul>
          <li>les niveaux de disponibilité ;</li>
          <li>les modalités de support ;</li>
          <li>les délais d’intervention ;</li>
          <li>les exclusions ;</li>
          <li>les compensations éventuelles.</li>
        </ul>

        <Title level={3}>2. DÉFINITIONS</Title>
        <Paragraph>
          <Text strong>Service</Text> : accès à la plateforme web et mobile permettant la diffusion et la gestion de contenus musicaux en environnement professionnel.
        </Paragraph>
        <Paragraph>
          <Text strong>Incident</Text> : dysfonctionnement empêchant ou altérant significativement l’usage normal du Service.
        </Paragraph>
        <Paragraph>
          <Text strong>Heures ouvrées</Text> : du lundi au vendredi, de 9h00 à 18h00 (heure de Paris), hors jours fériés français.
        </Paragraph>

        <Title level={3}>3. DISPONIBILITÉ DU SERVICE</Title>
        <Title level={4}>3.1 Engagement de disponibilité</Title>
        <Paragraph>
          La Société s’engage à assurer une disponibilité mensuelle du Service de :
        </Paragraph>
        <Paragraph style={{ paddingLeft: '1.25em' }}>
          <Text strong>99 % sur une base mensuelle</Text>
        </Paragraph>
        <Paragraph>La disponibilité est calculée comme suit :</Paragraph>
        <Paragraph style={{ padding: '0.625em', textAlign: 'center', fontFamily: 'monospace' }}>
          Disponibilité (%) =[(Temps total mensuel – Temps d’indisponibilité non planifiée) / Temps total mensuel] × 100
        </Paragraph>

        <Title level={4}>3.2 Exclusions</Title>
        <Paragraph>Ne sont pas considérées comme indisponibilités :</Paragraph>
        <ul>
          <li>maintenance planifiée notifiée au moins 24h à l’avance ;</li>
          <li>cas de force majeure ;</li>
          <li>défaillance du réseau internet du Client ;</li>
          <li>mauvaise configuration ou matériel défectueux du Client ;</li>
          <li>interruption liée à un tiers (hébergeur, fournisseur cloud, etc.).</li>
        </ul>

        <Title level={3}>4. MAINTENANCE</Title>
        <Paragraph>La Société peut procéder à :</Paragraph>
        <Paragraph><Text strong>Maintenance planifiée</Text></Paragraph>
        <ul>
          <li>réalisée en dehors des heures ouvrées dans la mesure du possible ;</li>
          <li>notification préalable par email ou via la plateforme.</li>
        </ul>
        <Paragraph><Text strong>Maintenance corrective</Text></Paragraph>
        <ul>
          <li>intervention dès détection d’un incident critique.</li>
        </ul>

        <Title level={3}>5. SUPPORT TECHNIQUE</Title>
        <Paragraph>Le support est accessible via :</Paragraph>
        <ul>
          <li>email : hello@musictmm.fr</li>
          <li>interface d’administration (ticketing si disponible)</li>
        </ul>

        <Title level={3}>6. NIVEAUX D’INCIDENT ET DÉLAIS D’INTERVENTION</Title>
        <Table 
          columns={slaColumns} 
          dataSource={slaData} 
          pagination={false} 
          bordered 
          size="small"
          scroll={{ x: true }}
          style={{ marginBottom: '1.25em' }} 
        />
        <Paragraph>
          <Text italic>Les délais sont des objectifs et non des obligations de résultat.</Text>
        </Paragraph>

        <Title level={3}>7. OBLIGATIONS DU CLIENT</Title>
        <Paragraph>Le Client s’engage à :</Paragraph>
        <ul>
          <li>maintenir une connexion internet stable ;</li>
          <li>utiliser un matériel compatible ;</li>
          <li>signaler tout incident sans délai ;</li>
          <li>coopérer raisonnablement avec la Société.</li>
        </ul>

        <Title level={3}>8. SÉCURITÉ</Title>
        <Paragraph>
          La Société met en œuvre des mesures techniques et organisationnelles raisonnables afin d’assurer :
        </Paragraph>
        <ul>
          <li>la sécurité des données ;</li>
          <li>la protection contre les accès non autorisés ;</li>
          <li>la continuité d’activité.</li>
        </ul>
        <Paragraph>Toutefois, la Société est tenue d’une obligation de moyens.</Paragraph>

        <Title level={3}>9. ÉVOLUTION DU SLA</Title>
        <Paragraph>
          La Société peut faire évoluer le présent SLA afin de l’adapter à l’évolution technologique ou réglementaire.
        </Paragraph>
        <Paragraph>Toute modification substantielle fera l’objet d’une notification préalable.</Paragraph>

        <Title level={3}>10. EXCLUSION DE RESPONSABILITÉ INDIRECTE</Title>
        <Paragraph>
          La Société ne saurait être tenue responsable des pertes indirectes, pertes d’exploitation ou atteintes à l’image résultant d’une interruption du Service.
        </Paragraph>

        <Title level={2}>ANNEXE 2 – DROITS D’AUTEUR ET DROITS VOISINS</Title>
        <Paragraph>
          <Text strong>Modèle de licence directe – MusicTMM</Text>
        </Paragraph>

        <Title level={3}>1. OBJET</Title>
        <Paragraph>
          La présente Annexe a pour objet de préciser le régime applicable aux droits d’auteur et aux droits voisins relatifs aux contenus musicaux diffusés via la plateforme « MusicTMM-Universum ».
        </Paragraph>

        <Title level={3}>2. DROITS D’AUTEUR – LICENCE DIRECTE</Title>
        <Paragraph>
          Les contenus musicaux mis à disposition sur la Plateforme sont :
        </Paragraph>
        <ul>
          <li>soit des œuvres dont MusicTMM SAS détient directement les droits patrimoniaux d’exploitation ;</li>
          <li>soit des œuvres exploitées en vertu de contrats de licence directe conclus avec les titulaires de droits.</li>
        </ul>
        <Paragraph>
          À la date des présentes, ces œuvres ne sont pas confiées à des sociétés de gestion collective d’auteurs pour la gestion des droits d’auteur relatifs à leur diffusion via la Plateforme.
        </Paragraph>
        <Paragraph>En conséquence :</Paragraph>
        <ul>
          <li>Le Client règle à MusicTMM SAS la rémunération correspondant aux droits d’auteur intégrés dans l’abonnement ou la facturation contractuelle applicable.</li>
          <li>
            <Text strong>Sous réserve du respect des CGU et du contrat commercial, aucune déclaration ni paiement supplémentaire au titre des droits d’auteur auprès de sociétés de gestion collective d’auteurs n’est requis pour la diffusion des œuvres fournies exclusivement via la Plateforme.</Text>
          </li>
        </ul>

        <Title level={3}>3. LIMITATION DU PÉRIMÈTRE</Title>
        <Paragraph>
          La couverture des droits d’auteur visée à l’article 2 est strictement limitée :
        </Paragraph>
        <ul>
          <li>aux œuvres effectivement mises à disposition par MusicTMM SAS ;</li>
          <li>à leur diffusion via la Plateforme ;</li>
          <li>à l’usage professionnel déclaré par le Client.</li>
        </ul>
        <Paragraph>
          Toute diffusion d’œuvres tierces extérieures à la Plateforme demeure de la responsabilité exclusive du Client.
        </Paragraph>

        <Title level={3}>4. DROITS VOISINS – RÉGIME INTERNATIONAL ET RÉMUNÉRATION ÉQUITABLE</Title>
        <Paragraph>
          MusicTMM SAS déclare contrôler, directement ou par voie contractuelle, les droits voisins relatifs aux phonogrammes mis à disposition sur la Plateforme.
        </Paragraph>
        <Paragraph>
          Toutefois, la réglementation applicable aux droits voisins, et notamment au mécanisme de rémunération équitable pour la communication au public de phonogrammes, varie selon les juridictions.
        </Paragraph>
        <Paragraph>
          Dans certaines juridictions, des sociétés chargées de la gestion ou de la collecte de la rémunération équitable au bénéfice des artistes-interprètes et producteurs peuvent, selon la réglementation applicable, réclamer le paiement d’une redevance, indépendamment de l’existence d’une gestion collective des droits voisins sur les œuvres concernées.
        </Paragraph>
        <Paragraph>En conséquence :</Paragraph>
        <ul>
          <li>les obligations éventuelles de déclaration et de paiement au titre de la rémunération équitable pour communication au public sont susceptibles de dépendre du pays dans lequel la diffusion est effectuée ;</li>
          <li>sauf stipulation contractuelle spécifique contraire, le Client demeure responsable du respect des obligations locales applicables dans le pays d’exploitation.</li>
        </ul>
        <Paragraph>
          Afin de déterminer si une obligation de déclaration ou de paiement est applicable dans le territoire concerné, le Client est invité à contacter la Société à l’adresse suivante : <Text code>hello@musictmm.fr</Text>
        </Paragraph>

        <Title level={3}>5. GARANTIES DE MUSIC TMM</Title>
        <Paragraph>
          MusicTMM SAS déclare disposer des droits nécessaires à la mise à disposition des œuvres incluses dans la Plateforme dans le cadre de la licence directe décrite à l’article 2.
        </Paragraph>
        <Paragraph>
          La Société garantit le Client contre toute action fondée sur une atteinte aux droits d’auteur concernant les œuvres fournies via la Plateforme, sous réserve :
        </Paragraph>
        <ul>
          <li>du respect strict des conditions contractuelles ;</li>
          <li>de l’absence de modification, extraction ou usage non autorisé des contenus.</li>
        </ul>

        <Title level={3}>6. QUALIFICATION JURIDIQUE</Title>
        <Paragraph>Les parties reconnaissent que MusicTMM SAS agit :</Paragraph>
        <ul>
          <li>en qualité de fournisseur de contenus musicaux sous licence directe ;</li>
          <li>en qualité d’opérateur de plateforme SaaS.</li>
        </ul>
        <Paragraph>
          La Société n’agit ni en qualité d’organisme de gestion collective, ni en qualité d’exploitant d’établissement diffusant au public.
        </Paragraph>

        <Title level={3}>7. ÉVOLUTION RÉGLEMENTAIRE</Title>
        <Paragraph>
          En cas d’évolution législative ou réglementaire affectant le régime applicable aux droits d’auteur ou aux droits voisins, les parties conviennent d’adapter leurs relations contractuelles de bonne foi.
        </Paragraph>

        <Title level={2}>ANNEXE 3 - POLITIQUE DE CONFIDENTIALITÉ</Title>
        <Paragraph>
          MusicTMM SAS Date d’entrée en vigueur : 11 février 2025
        </Paragraph>

        <Title level={3}>1. IDENTIFICATION DU RESPONSABLE DU TRAITEMENT</Title>
        <Paragraph>
          MusicTMM SAS<br />
          99 Avenue Achille Peretti<br />
          92200 Neuilly-sur-Seine<br />
          France<br />
          Email : hello@musictmm.fr
        </Paragraph>
        <Paragraph>
          MusicTMM SAS agit exclusivement en qualité de <Text strong>Responsable du traitement</Text> pour les données collectées dans le cadre de l’exploitation de la plateforme web et mobile « MusicTMM-Universum ».
        </Paragraph>
        <Paragraph>
          La Société exerce une activité strictement B2B et ne collecte aucune donnée relative aux clients finaux des établissements utilisant la Plateforme.
        </Paragraph>

        <Title level={3}>2. CATÉGORIES DE DONNÉES TRAITÉES</Title>
        <Title level={4}>2.1 Données d’identification professionnelle</Title>
        <ul>
          <li>adresse email professionnelle</li>
          <li>nom de l’entreprise</li>
          <li>nom du représentant</li>
          <li>adresse commerciale</li>
          <li>numéro de téléphone professionnel</li>
        </ul>

        <Title level={4}>2.2 Données techniques</Title>
        <ul>
          <li>adresse IP</li>
          <li>type et modèle d’appareil</li>
          <li>système d’exploitation</li>
          <li>journaux de connexion</li>
          <li>historique d’utilisation</li>
        </ul>

        <Title level={4}>2.3 Données de localisation</Title>
        <ul>
          <li>localisation approximative (pays, ville)</li>
        </ul>
        <Paragraph>
          Aucune donnée GPS précise n’est collectée sans consentement explicite. Aucune donnée sensible au sens de l’article 9 du RGPD n’est traitée.
        </Paragraph>
        <Paragraph>
          Aucun profilage ni prise de décision automatisée produisant des effets juridiques n’est réalisé.
        </Paragraph>

        <Title level={3}>3. FINALITÉS ET BASES LÉGALES</Title>
        <Paragraph>Les données sont traitées aux fins suivantes :</Paragraph>
        <Table 
          columns={rgpdColumns} 
          dataSource={rgpdData} 
          pagination={false} 
          bordered 
          size="small"
          scroll={{ x: true }}
          style={{ marginBottom: '1.25em' }} 
        />
        <Paragraph>
          Les intérêts légitimes poursuivis incluent notamment la sécurité de la Plateforme, la prévention des fraudes et l’amélioration continue des services.
        </Paragraph>
        <Paragraph>
          Lorsque le traitement est fondé sur l’intérêt légitime, la personne concernée peut s’y opposer pour des raisons tenant à sa situation particulière.
        </Paragraph>

        <Title level={3}>4. SOUS-TRAITANTS</Title>
        <Paragraph>
          Certaines données peuvent être traitées par des prestataires techniques agissant pour le compte de MusicTMM SAS, notamment :
        </Paragraph>
        <ul>
          <li>hébergeurs cloud situés dans l’Union européenne ;</li>
          <li>prestataires techniques ;</li>
          <li>services de maintenance.</li>
        </ul>
        <Paragraph>
          Ces prestataires sont liés par des contrats conformes à l’article 28 du RGPD.
        </Paragraph>
        <Paragraph>
          La liste des sous-traitants peut être communiquée sur demande.
        </Paragraph>

        <Title level={3}>5. TRANSFERTS INTERNATIONAUX</Title>
        <Paragraph>Les données sont hébergées au sein de l’Union européenne.</Paragraph>
        <Paragraph>
          En cas de transfert vers un pays tiers, celui-ci sera encadré par des garanties appropriées, notamment :
        </Paragraph>
        <ul>
          <li>les clauses contractuelles types adoptées par la Commission européenne ;</li>
          <li>ou tout autre mécanisme reconnu conforme au RGPD.</li>
        </ul>

        <Title level={3}>6. DURÉE DE CONSERVATION</Title>
        <Paragraph>Les données sont conservées :</Paragraph>
        <ul>
          <li>pendant la durée de la relation contractuelle ;</li>
          <li>puis archivées conformément aux obligations légales applicables (notamment comptables) ;</li>
          <li>les données de facturation sont conservées dix (10) ans ;</li>
          <li>les journaux techniques sont conservés pour une durée maximale de douze (12) mois ;</li>
          <li>au-delà, les données sont supprimées ou anonymisées.</li>
        </ul>

        <Title level={3}>7. SÉCURITÉ</Title>
        <Paragraph>
          MusicTMM SAS met en œuvre des mesures techniques et organisationnelles appropriées, notamment :
        </Paragraph>
        <ul>
          <li>chiffrement des données en transit ;</li>
          <li>contrôle d’accès restreint ;</li>
          <li>journalisation des accès ;</li>
          <li>sauvegardes régulières.</li>
        </ul>
        <Paragraph>La Société est tenue d’une obligation de moyens.</Paragraph>

        <Title level={3}>8. DROITS DES PERSONNES CONCERNÉES</Title>
        <Paragraph>Conformément au RGPD, toute personne concernée dispose des droits suivants :</Paragraph>
        <ul>
          <li>droit d’accès</li>
          <li>droit de rectification</li>
          <li>droit d’effacement</li>
          <li>droit à la limitation</li>
          <li>droit d’opposition</li>
          <li>droit à la portabilité</li>
        </ul>
        <Paragraph>
          Les demandes peuvent être adressées à : <Text code>hello@musictmm.fr</Text>
        </Paragraph>
        <Paragraph>Elles seront traitées dans un délai maximal d’un (1) mois.</Paragraph>
        <Paragraph>
          En cas de litige, une réclamation peut être introduite auprès de la CNIL (www.cnil.fr).
        </Paragraph>

        <Title level={3}>9. VIOLATION DE DONNÉES</Title>
        <Paragraph>
          En cas de violation de données personnelles susceptible d’engendrer un risque pour les droits et libertés des personnes, MusicTMM SAS notifiera l’autorité compétente et, le cas échéant, les personnes concernées conformément aux articles 33 et 34 du RGPD.
        </Paragraph>

        <Title level={3}>10. MODIFICATIONS</Title>
        <Paragraph>
          La présente Politique peut être mise à jour à tout moment afin de tenir compte d’évolutions réglementaires ou techniques.
        </Paragraph>
        <Paragraph>
          Toute modification substantielle sera notifiée via la Plateforme ou par email.
        </Paragraph>
    </Layout>
  );
};

export default TermsFR;